import { SearchOutlined } from "@ant-design/icons";
import { Button, Input, Row, Select, Space, Typography } from "antd";
import React, { useState } from "react";
import DHLTracking from "../../components/tracking/DHLTracking";
import FedexTracking from "../../components/tracking/FedexTracking";
import {
  useTrackDhlShipment,
  useTrackFedexShipment,
} from "../../query/Tracking";

const Tracking: React.FC = () => {
  const [trackingNumber, setTrackingNumber] = useState<string>("");
  const [searchedNumber, setSearchedNumber] = useState<string>("");
  const [courier, setCourier] = useState<string>("dhl");

  const {
    data: shipmentData,
    isLoading,
    error,
  } = useTrackDhlShipment(courier === "dhl" ? searchedNumber : "");

  const {
    data: fedexData,
    isLoading: isFedexLoading,
    error: fedexError,
  } = useTrackFedexShipment(courier === "fedex" ? searchedNumber : "");

  const handleCourierChange = (value: string) => {
    setCourier(value);
    setSearchedNumber("");
  };

  const handleSearch = () => {
    if (trackingNumber) {
      setSearchedNumber(trackingNumber);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="p-4">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 24,
        }}
      >
        <Typography.Title
          style={{
            textTransform: "uppercase",
            margin: 0,
            fontFamily: "Chakra Petch",
          }}
          level={3}
          className="dark:text-white"
        >
          Tra cứu vận đơn
        </Typography.Title>
      </div>
      <Space style={{ marginBottom: 16 }}>
        <Select
          value={courier}
          onChange={handleCourierChange}
          style={{ width: 120 }}
          options={[
            { value: "dhl", label: "DHL" },
            { value: "fedex", label: "FedEx" },
            // { value: "ups", label: "UPS" },
            // { value: "vietnam-post", label: "Vietnam Post" },
          ]}
        />
        <Input
          placeholder="Nhập mã vận đơn"
          value={trackingNumber}
          onChange={(e) => setTrackingNumber(e.target.value)}
          onKeyPress={handleKeyPress}
          style={{ width: 300 }}
          prefix={<SearchOutlined />}
        />
        <Button type="primary" onClick={handleSearch}>
          Tra cứu
        </Button>
      </Space>

      <Row gutter={[14, 16]}>
        {courier === "dhl" && (
          <DHLTracking
            error={error}
            isLoading={isLoading}
            shipmentData={shipmentData}
          />
        )}
        {courier === "fedex" && (
          <FedexTracking
            error={fedexError}
            isLoading={isFedexLoading}
            shipmentData={fedexData}
          />
        )}
      </Row>
    </div>
  );
};

export default Tracking;
